/** @jsx jsx */ import { jsx } from '@emotion/core'
import * as React from 'react'
import StyledComponent, { GetStylesType } from './StyledComponent'
import { SkipButton as SBtn } from '../Styles/index'
import { AudioContext } from '../Context'
import { ClickProp } from './Buttons'

const SkipButton: React.FC<SkipButtonProps> = ({
  onClick,
  direction,
  disabled,
  styles,
}) => {
  const { play, isPaused } = React.useContext(AudioContext)
  return (
    <StyledComponent styles={styles}>
      {({ getStyles }: { getStyles: GetStylesType }) => (
        <button
          onClick={
            !disabled
              ? onClick
                ? e => onClick(e, { play, isPaused })
                : () => {}
              : () => {}
          }
          css={getStyles('skipButton', { disabled })}
          disabled={disabled}
        >
          <svg
            viewBox="0 0 12 14"
            css={{
              ...(direction === 'next' ? { transform: 'rotate(180deg)' } : {}),
            }}
          >
            <path
              fill="currentColor"
              d="M10.705 13.632L2.833 7.618a.77.77 0 010-1.23L10.705.374C11.231-.028 12 .338 12 .989v12.028c0 .651-.769 1.017-1.295.615zm-9.671.276c-.569 0-1.036-.455-1.036-1.01V1.09C-.002.534.465.079 1.034.079c.57 0 1.036.455 1.036 1.011v11.808c0 .555-.466 1.01-1.036 1.01z"
            />
          </svg>
        </button>
      )}
    </StyledComponent>
  )
}

export default SkipButton

type SkipButtonProps = {
  onClick?: ClickProp
  direction?: 'prev' | 'next'
  disabled?: boolean
  styles?: SBtn.StylesObj
}
